import React, { useState, useRef } from 'react';
import './StickyNote.css'; // Reuse existing styles

const NotePreviewSticky = ({ selectedNote, onClose, isInMainPanel = true }) => {
  const [isMinimized, setIsMinimized] = useState(true);
  const [position, setPosition] = useState({ x: 1, y: 45 }); // Default position
  




  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  if (!selectedNote) return null;

  return (
    <div
      className={`sticky note-preview-sticky ${isMinimized ? 'minimized' : ''}`}
      style={{
        position: 'absolute',
        left: position.x,
        top: position.y,
        width: 550,  // Changed from 400
        height: isMinimized ? 45 : 650,  // Changed from 300
        zIndex: 1000000000000 
      }}
    >
      <div 
        className="drag-bar" 
        
        onDoubleClick={toggleMinimize}

      >
        <span>📄 Note Preview - {selectedNote.title || 'Untitled'}</span>
        <div className="sticky-controls">
          <button onClick={toggleMinimize}>
            {isMinimized ? '□' : '−'}
          </button>
          <button onClick={onClose}>✖</button>
        </div>
      </div>
      
      {!isMinimized && (
        <div 
          className="note-content-display"
          style={{
            padding: '10px',
            height: 'calc(100% - 45px)',
            overflow: 'auto',
            backgroundColor: 'var(--stickyNoteBg)',
            fontSize: '14px',
            lineHeight: '1.4'
          }}
          dangerouslySetInnerHTML={{ __html: selectedNote.note || '<p>No content</p>' }}
        />
      )}
    </div>
  );
};

export default NotePreviewSticky;